import { render, staticRenderFns } from "./AssignBlindModal.vue?vue&type=template&id=03089155&"
import script from "./AssignBlindModal.vue?vue&type=script&lang=js&"
export * from "./AssignBlindModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignBlindModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports